module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/081-bermuda-cc4f2f262fcff340254893e2b116ee36.svg";